import { api } from "../../api";
import { EditPersonalDataTypes } from "../interface";

export async function editPersonalData(data: EditPersonalDataTypes) {
  const payload: Record<string, string | undefined> = {};
  if (data.first_name !== undefined) payload.firstName = data.first_name;
  if (data.last_name !== undefined) payload.lastName = data.last_name;
  if (data.phone_number !== undefined) payload.phoneNumber = data.phone_number;
  if (data.email !== undefined) payload.email = data.email;
  if (data.birth_date !== undefined) payload.birthDate = data.birth_date;
  if (data.language_code !== undefined)
    payload.languageCode = data.language_code;

  const res = await api.patch("/me", payload);
  return res.data;
}

/**
 * Отдельный вызов «сохранить язык интерфейса». Отправляем на бэк, чтобы
 * бот и e-mail-нотификации приходили на нужном языке. Ошибки глотаем
 * тихо: даже если сервер временно недоступен, UI уже переключился —
 * не портим пользователю впечатление.
 */
export async function saveLanguagePreference(lang: string) {
  try {
    await api.patch("/me", { languageCode: lang });
  } catch {
    /* no-op — оффлайн-переключение всё равно сохранится в localStorage */
  }
}
